import PdfTab from '@/components/Shared/PdfTab';
import DocumentExplorer from '@/pages/document-explorer/routes/DocumentExplorer';
import PortalDocumentExplorer from '@/pages/document-explorer/routes/PortalDocumentExplorer';
import TaxDocumentTab from '@/pages/tax/routes/TaxDocumentsRecord/pages/TaxDocumentTab';
import CalculatorPage from '@/pages/tax/routes/SharedTaxComponents/CalculatorPage';

export const publicRoutes = [
  {
    path: '/pdf-tab',
    element: <PdfTab />,
  },
  {
    path: '/document-explorer/assessment/:assessmentId',
    element: <PortalDocumentExplorer />,
  },
  {
    path: '/document-explorer/:dealId',
    element: <DocumentExplorer />,
  },
  {
    path: '/tax-documents/:dealId',
    element: <TaxDocumentTab />,
  },
  {
    path: '/calculator',
    element: <CalculatorPage />,
  },
];
